export default __webpack_public_path__ + "static/media/guides.67678840.png";